import { styled } from '@innowise-group/mui-kit';

export const OptionWrapper = styled.span``;
export const OptionValue = styled.span``;
export const OptionComment = styled.span`
  color: ${({ theme }) => theme.palette.general.darkGrey[40]};
`;
